import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/_layout/account/delete/')({
  component: () => <Navigate to="/account/delete/landing" />,
});
